module.exports = __webpack_public_path__ + "static/media/0025_IMG_LES_MURS_P21_UNI_TROPICAL_VERTICALE.ab12a1d1.png";